import React, { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import AppRouter from "./AppRouter";
import ErrorBoundary from "./components/ErrorBoundary";
import theme from "./styles/theme";
import { AuthProvider, useAuth } from "./firebase";
import { SnackbarProvider } from "notistack";
import { ShoppingCartProvider } from "./pages/Checkout/ShoppingCartProvider";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { initGlobalErrorReporting } from "./utils/errorReporting";
// import "./utils/createSampleData"; // Import sample data utilities - temporarily disabled

initGlobalErrorReporting();

const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || "";
if (!PAYPAL_CLIENT_ID) {
  console.error("REACT_APP_PAYPAL_CLIENT_ID is not set in environment variables");
}


const App: React.FC = () => {
  return (
    <div className="App" data-testid="app">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <ShoppingCartProvider>
            <SnackbarProvider maxSnack={3}>
              <PayPalScriptProvider options={{ clientId: PAYPAL_CLIENT_ID }}>
                <ErrorBoundary>
                  <AppRouter />
                </ErrorBoundary>
              </PayPalScriptProvider>
            </SnackbarProvider>
          </ShoppingCartProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
};

export default App;
